import debounce from 'lodash/debounce';
import { DEFINITIONS } from '../utils/constants';

// --- Debounced resize handler to update UI on window resize ---
export const updateUIOnResize = (context) => {
  const storesContainerDesktop = context.querySelector(`.${DEFINITIONS.slug}__stores-container--desktop`);
  const storesContainerMobile = context.querySelector(`.${DEFINITIONS.slug}__stores-container--mobile`);

  if (!storesContainerDesktop || !storesContainerMobile) {
    console.error('Store locator desktop/mobile containers not found');
    return;
  }

  const moveStoresContent = () => {
    // Move storesContainer children to the correct container based on screen size
    const isDesktop = window.innerWidth >= DEFINITIONS.breakpoints.UISwitch;
    const targetContainer = isDesktop ? storesContainerDesktop : storesContainerMobile;
    const sourceContainer = isDesktop ? storesContainerMobile : storesContainerDesktop;
    // Check if the source container has children to move or if children are already in the target container
    if (sourceContainer.children.length > 0 && !targetContainer.contains(sourceContainer.children[0])) {
      while (sourceContainer.firstChild) {
        targetContainer.appendChild(sourceContainer.firstChild);
      }
    }
  };

  // Initial move on load
  moveStoresContent();
  // Add resize listener to move content on window resize
  window.addEventListener('resize', debounce(moveStoresContent, 100));
};
